import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { CompletedFormsService } from "./completed-forms.service";
import { MatTableDataSource } from '@angular/material/table';
import * as _ from 'lodash';
import { S3Service } from '../services/s3.service';
import { Router } from '@angular/router';
import { DashboardService } from '../dashboard/dashboard.service';
import { SharedService } from '../services/shared.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import * as moment from 'moment-timezone';
import { MatSort } from '@angular/material/sort';
import { FilterService } from '../services/filter.service';

@Component({
  selector: "app-completed-forms",
  templateUrl: "./completed-forms.component.html",
  styleUrls: ["./completed-forms.component.scss"],
})
export class CompletedFormsComponent implements OnInit {
  @ViewChild(MatSort) sort: MatSort;
  sortForms = ["All Forms"];
  displayNoRecords: boolean = false;
  displayedColumns = [
    "select",
    "sortTopics",
    "subTopics",
    "name",
    "sortSenders",
    "sortForms",
    "sortTime",
    "star",
  ];
  completedForms: any = [];
  bgTextColor = "#000000";
  sortTopics = ["All Topics"];
  sortSubTopics = ["All Sub Topics"];
  sortSenders = ["All Senders"];

  filteredTopic = "";
  filteredSubtopic = "";
  filteredSender = "";
  filteredForm = "";
  tableDataSource = [];
  userPriveleges = [];
  timezone;

  constructor(
    private _completedFormsService: CompletedFormsService,
    private _s3Service: S3Service,
    private _router: Router,
    private _dashboardService: DashboardService,
    private _sharedService: SharedService,
    private _snackBar: MatSnackBar,
    private _changeDetectionRef: ChangeDetectorRef,
    private _filterService: FilterService
  ) {
    this._sharedService.searchChange.subscribe((value) => {
      this.completedForms.filter = value.toLowerCase();
      if (this.completedForms.filteredData.length === 0) {
        this.displayNoRecords = true;
      } else {
        this.displayNoRecords = false;
      }
      this.updateFiltersForSearch();
    });
  }

  ngOnInit() {
    this.timezone = localStorage.getItem('timezone');
    this.onInit();
  }

  ngAfterViewChecked() {
    if (this.check(this.bgTextColor)) {
      this._sharedService.updateHomeColor(this.bgTextColor);
    }
  }

  check(hex) {
    if (/[0-9A-F]{6}$/i.test(hex)) {
      return true;
    }
  }

  onInit(): void {
    this._sharedService.getPrivileges(localStorage.getItem('role')).subscribe((response) => {
      if (response['success']) {
        this.userPriveleges = response['data'][0]['privileges'];
      }
      let isHelpAdmin = false
      if (this.checkPrivilege("help_forms")) {
        isHelpAdmin = true
      }
      let searchInput = document.getElementById("searchInput");
      if (localStorage.getItem("bgTextColor"))
        this.bgTextColor = localStorage.getItem("bgTextColor");
      this.sortTopics = ["All Topics"];
      this.sortSubTopics = ["All Sub Topics"];
      this.sortSenders = ["All Senders"];
      this.sortForms = ["All Forms"];
      this.filteredTopic = "";
      this.filteredSubtopic = "";
      this.filteredSender = "";
      this.filteredForm = "";
      searchInput["value"] = "";
      this.displayNoRecords = false;
      this.completedForms = [];
      this._completedFormsService
        .getCompletedForms(localStorage.getItem("organization"), isHelpAdmin)
        .subscribe(
          (response) => {
            if (response["success"]) {
              if (response["data"] && response["data"].length > 0) {
                let completedForms = response["data"];
                if (completedForms.length > 0) {
                  completedForms.forEach((form) => {
                    form["sortTopics"] = form["sortTopics"]
                      ? _.isString(form["sortTopics"])
                        ? form["sortTopics"]
                        : Object.values(form["sortTopics"])[0]
                      : "";
                    form["subTopics"] = form["subTopics"]
                      ? _.isString(form["subTopics"])
                        ? form["subTopics"]
                        : Object.values(form["subTopics"])[0]
                      : "";

                    if (!_.includes(this.sortTopics, form["sortTopics"])) {
                      if (form["sortTopics"] && form["sortTopics"].length !== 0) {
                        this.sortTopics.push(form["sortTopics"]);
                      }
                    }

                    if (!_.includes(this.sortSubTopics, form["subTopics"])) {
                      if (form["subTopics"] && form["subTopics"].length !== 0) {
                        this.sortSubTopics.push(form["subTopics"]);
                      }
                    }

                    if (!_.includes(this.sortSenders, form["sortSenders"])) {
                      if (form["sortSenders"] && form["sortSenders"].length !== 0) {
                        this.sortSenders.push(form["sortSenders"]);
                      }
                    }

                    if (!_.includes(this.sortForms, form.sortForms)) {
                      if (form["sortForms"] && form["sortForms"].length !== 0) {
                        this.sortForms.push(form["sortForms"])
                      }
                    }

                    if (this.timezone) {
                      form['sortTime'] = moment(form['sortTime']).tz(this.timezone).format('llll')
                    }

                    // // Fetching images
                    // let template_schema = form["template"]["template_schema"]["schema"];
                    // let response = form["response"];

                    // template_schema.forEach((element) => {
                    //   for (let i = 0; i < Object.keys(response).length ; i++) {
                    //     if (response[element.key] !== undefined) {
                    //       element["value"] = response[element.key];
                    //     }
                    //   }

                    //   if (element.type === 'picture') {
                    //     if (element["value"] && element["value"].length > 0) {
                    //       form["raw_images"] = [];
                    //       for (let j = 0; j < element["value"].length; j++) {
                    //         if (j === 2) {
                    //           break;
                    //         }
                    //         this._s3Service.getObjectFromKey(element["value"][j]).subscribe((response) => {
                    //           var binary = '';
                    //           var bytes = new Uint16Array(response['data']);
                    //           var len = bytes.byteLength;
                    //           for (var i = 0; i < len; i++) {
                    //             binary += String.fromCharCode(bytes[i]);
                    //           }
                    //           let image = "data:image/jpeg;base64," + window.btoa(binary);
                    //           form["raw_images"].push({ src: image });
                    //         }, (error) => {
                    //           console.log(error);
                    //         });
                    //       }
                    //     }
                    //   }
                    // });
                  });
                  this.sortFilters()
                  this.completedForms = new MatTableDataSource(completedForms);
                  this.completedForms.sort = this.sort;
                  this._completedFormsService.refreshCount([]);
                  this.tableDataSource = completedForms;
                }
              }
            }
            this.sortFilters()
          },
          (error) => {
            console.log(error);
          }
        );
    })
  }

  getFormDetails(formId) {
    this._router.navigateByUrl("/formDetails/Completed/" + formId);
  }

  deleteSubmittedForm(formId, template?) {
    // this._sharedService.confirmationDialog(
    //   "This action will move the form to Trash",
    //   () => {
    let requestData = {
      formId: formId,
      template: template
    };
    if (template == environment.help_form_id) {
      requestData['deleted_by'] = {
        username: localStorage.getItem('username'),
        user_id: localStorage.getItem('userId'),
        organization_id: localStorage.getItem('organization')
      }
    }

    this._dashboardService.deleteSubmittedForm(requestData).subscribe(
      (response) => {
        if (response["success"]) {
          this.openSnackBar(response["message"]);
          let forms = this.completedForms._data._value;
          let formIndex = this.completedForms._data._value.findIndex((form) => form._id === formId);
          forms.splice(formIndex, 1);
          this.updateTable(forms);
        }
      },
      (error) => {
        console.log(error);
      }
    );
    //   }
    // );
  }

  restoreArchivedForm(formId) {
    // this._sharedService.confirmationDialog(
    //   "Are you sure you want to restore this form?",
    //   () => {
    let requestData = {
      formIds: [formId],
    };

    this._completedFormsService.restoreArchivedForms(requestData).subscribe(
      (response) => {
        this.openSnackBar(response["message"]);
        let forms = this.completedForms._data._value;
        let formIndex = this.completedForms._data._value.findIndex((form) => form._id === formId);
        forms.splice(formIndex, 1);
        this.updateTable(forms);
      },
      (error) => {
        console.log(error);
        this.openSnackBar("Server side error occurred");
      }
    );
    //   }
    // );
  }

  updateTable(forms) {
    this.sortForms = ["All Forms"];
    this.sortTopics = ["All Topics"];
    this.sortSubTopics = ["All Sub Topics"];
    this.sortSenders = ["All Senders"];
    if (forms && forms.length > 0) {
      forms.forEach((form) => {
        form["checked"] = false;
        form["sortTopics"] = form["sortTopics"] ? (_.isString(form["sortTopics"]) ? form["sortTopics"] : Object.values(form["sortTopics"])[0]) : '';
        form["subTopics"] = form["subTopics"] ? (_.isString(form["subTopics"]) ? form["subTopics"] : Object.values(form["subTopics"])[0]) : '';

        if (!_.includes(this.sortForms, form.sortForms)) {
          this.sortForms.push(form.sortForms);
        }

        if (!_.includes(this.sortTopics, form["sortTopics"])) {
          if (form["sortTopics"].length !== 0) {
            this.sortTopics.push(form["sortTopics"])
          }
        }

        if (!_.includes(this.sortSubTopics, form["subTopics"])) {
          if (form["subTopics"].length !== 0) {
            this.sortSubTopics.push(form["subTopics"])
          }
        }

        if (!_.includes(this.sortSenders, form["sortSenders"])) {
          if (form["sortSenders"] && form["sortSenders"].length !== 0) {
            this.sortSenders.push(form["sortSenders"]);
          }
        }
      });

      this.completedForms = new MatTableDataSource(forms);
      this.tableDataSource = forms;
    } else {
      this.completedForms = []
      this.tableDataSource = [];
    }
  }

  openSnackBar(message) {
    this._snackBar.open(message, "Ok", {
      duration: 2000,
    });
  }

  onReloadClick(): void {
    this.onInit();
  }

  filterTopics(value): void {
    if (value === "All Topics") {
      this.filteredTopic = "";
    } else {
      this.filteredTopic = value;
    }
    this.applyFilters();
  }

  filterSubTopics(value): void {
    if (value == "All Sub Topics") {
      this.filteredSubtopic = "";
    } else {
      this.filteredSubtopic = value;
    }
    this.applyFilters();
  }

  filterSenders(value): void {
    if (value == "All Senders") {
      this.filteredSender = "";
    } else {
      this.filteredSender = value;
    }
    this.applyFilters();
  }

  filterForms(value): void {
    if (value == "All Forms") {
      this.filteredForm = "";
    } else {
      this.filteredForm = value;
    }
    this.applyFilters();
  }

  sortFilters() {
    this.sortTopics = this._filterService.sortFilterOptions(this.sortTopics, "All Topics");
    this.sortSubTopics = this._filterService.sortFilterOptions(this.sortSubTopics, "All Sub Topics");
    this.sortSenders = this._filterService.sortFilterOptions(this.sortSenders, "All Senders");
    this.sortForms = this._filterService.sortFilterOptions(this.sortForms, "All Forms");
  }
  checkPrivilege(accessType) {
    return this._sharedService.checkPrivilege(this.userPriveleges, accessType);
  }

  resetFilters() {
    this.filteredForm = "";
    this.filteredTopic = "";
    this.filteredSubtopic = "";
    this.filteredSender = "";
  }


  hasActiveFilters(): boolean {
    return this._filterService.hasActiveFilters({
      topic: this.filteredTopic,
      subtopic: this.filteredSubtopic,
      sender: this.filteredSender,
      form: this.filteredForm
    });
  }

  clearFilter(type: string): void {
    if (type === 'topic') this.filteredTopic = "";
    else if (type === 'subtopic') this.filteredSubtopic = "";
    else if (type === 'sender') this.filteredSender = "";
    else if (type === 'form') this.filteredForm = "";
    this.applyFilters();
  }

  applyFilters(): void {
    const filters = {
      topic: this.filteredTopic,
      subtopic: this.filteredSubtopic,
      sender: this.filteredSender,
      form: this.filteredForm
    };

    const filteredData = this._filterService.applyFilters(this.tableDataSource, filters);

    this.completedForms = new MatTableDataSource(filteredData);
    this.completedForms.sort = this.sort;
    this._changeDetectionRef.detectChanges();
    this.updateFilterLists();
    this.sortFilters();
  }

  // Dynamic update of dropdown lists based on active filters (faceted search)
  updateFilterLists() {
    const filters = {
      topic: this.filteredTopic,
      subtopic: this.filteredSubtopic,
      sender: this.filteredSender,
      form: this.filteredForm
    };

    const options = this._filterService.getFilterOptions(this.tableDataSource, filters);
    this.sortTopics = options.topics;
    this.sortSubTopics = options.subTopics;
    this.sortSenders = options.senders;
    this.sortForms = options.forms;
  }

	// Update filters based on search results
	updateFiltersForSearch() {
		const searchText = this._sharedService.searchText;
		const options = this._filterService.updateFiltersForSearch(this.completedForms, searchText);
		this.sortTopics = options.topics;
		this.sortSubTopics = options.subTopics;
		this.sortSenders = options.senders;
		this.sortForms = options.forms;
		this.sortFilters();
	}
}
